import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;
  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <>
      <DropdownMenuItem onClick={() => changeLanguage('en')}>
        <Globe className="mr-2 h-4 w-4" />
        {t('languages.en')}
        {currentLanguage === 'en' && (
          <span className="ml-auto text-xs text-muted-foreground">✓</span>
        )}
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => changeLanguage('fr')}>
        <Globe className="mr-2 h-4 w-4" />
        {t('languages.fr')}
        {currentLanguage === 'fr' && (
          <span className="ml-auto text-xs text-muted-foreground">✓</span>
        )}
      </DropdownMenuItem>
    </>
  );
}
